import {
  APPROVED_QUOTE_STATUS,
  DELIVERED_STATUS,
  SALES_APPROVED_QUOTE_STATUS,
  STARTED_PRODUCTION_STATUS,
  isAwaitingKlayderReview,
  isDraftQuoteStatus,
  SHIPPING_QUOTE_STATUS,
} from 'src/shared/consts/quoteStatus'

export type CheckoutMood =
  | 'waiting_klayder'
  | 'approve_quote'
  | 'awaiting_proofs'
  | 'approve_proofs'
  | 'confirm_order'
  | 'complete'

export const getCheckoutMood = (
  status: string,
  hasProofs: boolean
): CheckoutMood => {
  if (
    status === STARTED_PRODUCTION_STATUS ||
    status === SHIPPING_QUOTE_STATUS ||
    status === DELIVERED_STATUS
  ) {
    return 'complete'
  }
  if (status === APPROVED_QUOTE_STATUS) {
    return hasProofs ? 'approve_proofs' : 'awaiting_proofs'
  }
  if (status === SALES_APPROVED_QUOTE_STATUS) return 'approve_quote'
  if (isDraftQuoteStatus(status) || isAwaitingKlayderReview(status)) {
    return 'waiting_klayder'
  }
  return 'confirm_order'
}

export const checkoutMoodCopy = (
  mood: CheckoutMood,
  isAdmin: boolean,
  t: (en: string, sv?: string) => string
) => {
  if (mood === 'complete') {
    return {
      eyebrow: t('In production', 'I produktion'),
      title: t('Your merch is in production', 'Er merch är i produktion'),
      body: t('Follow the order on Delivery.', 'Följ ordern under Leverans.'),
    }
  }
  if (mood === 'confirm_order') {
    return {
      eyebrow: t('Confirm order', 'Bekräfta order'),
      title: t('Add billing and shipping', 'Lägg till faktura och leverans'),
      body: t(
        'Then start production. The order can no longer be changed.',
        'Sen startar produktionen. Ordern kan inte ändras efter det.'
      ),
    }
  }
  if (mood === 'approve_proofs') {
    return {
      eyebrow: t('Your turn', 'Din tur'),
      title: t('Approve the factory proofs', 'Godkänn korrekturerna'),
      body: isAdmin
        ? t(
            'Waiting for the customer to approve the factory proofs.',
            'Väntar på att kunden ska godkänna korrekturerna.'
          )
        : t(
            'Check that the design looks right. Then you can confirm the order.',
            'Kolla att designen ser rätt ut. Sedan kan du bekräfta ordern.'
          ),
    }
  }
  if (mood === 'awaiting_proofs') {
    return {
      eyebrow: t('Quote approved', 'Offert godkänd'),
      title: t('Waiting for factory proofs', 'Väntar på korrekturer'),
      body: t(
        'We will email you when they are ready to review.',
        'Vi mejlar dig när de är klara att granska.'
      ),
    }
  }
  if (mood === 'approve_quote') {
    return {
      eyebrow: t('Your turn', 'Din tur'),
      title: t('Approve the quote', 'Godkänn offerten'),
      body: isAdmin
        ? t(
            'The quote is with the customer. They approve next.',
            'Offerten är hos kunden. De godkänner härnäst.'
          )
        : t(
            'Review pricing, sizes, and colors. Then we request factory proofs.',
            'Granska pris, storlekar och färger. Sedan begär vi korrekturer.'
          ),
    }
  }
  return {
    eyebrow: t('In review', 'Under granskning'),
    title: isAdmin
      ? t('Review the quote', 'Granska offerten')
      : t('Klayder is reviewing the quote', 'Klayder granskar offerten'),
    body: isAdmin
      ? t(
          'Check pricing, sizes, and colors. Then the customer can approve.',
          'Kolla pris, storlekar och färger. Sedan kan kunden godkänna.'
        )
      : t(
          'We are checking pricing, sizes, and colors.',
          'Vi kollar pris, storlekar och färger.'
        ),
  }
}
